/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const GovernmentIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Government',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 36 36"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M35.5 32H34v-1.5a.5.5 0 0 0-.5-.5H32V14.828a2 2 0 0 1 .586-1.414L34 12H2l1.414 1.414A2 2 0 0 1 4 14.828V30H2.5a.5.5 0 0 0-.5.5V32H.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h35a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5ZM28 16v14h-2V16h2Zm-6 0v14h-2V16h2Zm-6 0v14h-2V16h2Zm-8 0h2v14H8V16Zm28-7.35V10H0V8.65a1 1 0 0 1 .594-.914L17.188.361a2 2 0 0 1 1.624 0l16.594 7.375A1 1 0 0 1 36 8.65Z"
    />
  </svg>`;
};
